import { render, staticRenderFns } from "./InstructionsForm.vue?vue&type=template&id=5dd9814e&scoped=true"
import script from "./InstructionsForm.vue?vue&type=script&lang=js"
export * from "./InstructionsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd9814e",
  null
  
)

export default component.exports